import { PropsWithChildren } from "react";

const Footer = ({ children }: PropsWithChildren) => {
  return (
    <footer className="pubr-footer">
      <div className="pubr-footer__inner">
        <div className="pubr-footer__inner-wrap">{children}</div>
      </div>
    </footer>
  );
};

export { Footer };
